import { Reference, TypePolicies } from '@apollo/client'

import { Config, ConfigPlugin } from '@lib/Config'

export class UserMenuPlugin implements ConfigPlugin {

  config!: Config

  async configure(config: Config): Promise<void> {
    this.config = config
  }

  typePolicies = (): TypePolicies => ({
    UserMenu: {
      fields: {
        dishes: {
          merge(_existing: Reference[], incoming: Reference[]): Reference[] {
            return incoming
          },
        },
      },
    },
  })

}
